import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const TextDocumentSearch = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 2H12V6H16V9H18V4.586L13.414 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V20C0 20.5304 0.210714 21.0391 0.585786 21.4142C0.960859 21.7893 1.46957 22 2 22H10V20H2V2Z"
      fill="currentColor"
    />
    <path d="M12 9H4V11H12V9Z" fill="currentColor" />
    <path d="M9 13H4V15H9V13Z" fill="currentColor" />
    <path
      d="M20.1667 18.753C20.8528 17.7164 21.1294 16.462 20.943 15.233C20.7566 14.0039 20.1204 12.888 19.1577 12.1015C18.1951 11.315 16.9747 10.914 15.7332 10.9764C14.4917 11.0387 13.3176 11.5599 12.4386 12.4389C11.5596 13.3179 11.0384 14.492 10.976 15.7335C10.9137 16.975 11.3147 18.1954 12.1012 19.1581C12.8876 20.1207 14.0036 20.7569 15.2326 20.9433C16.4617 21.1298 17.7161 20.8531 18.7527 20.167L21.9997 23.414L23.4137 22L20.1667 18.753ZM15.9997 19C15.4063 19 14.8263 18.8241 14.333 18.4944C13.8396 18.1648 13.4551 17.6962 13.228 17.1481C13.001 16.5999 12.9416 15.9967 13.0573 15.4147C13.1731 14.8328 13.4588 14.2982 13.8784 13.8787C14.2979 13.4591 14.8325 13.1734 15.4144 13.0576C15.9964 12.9419 16.5996 13.0013 17.1477 13.2284C17.6959 13.4554 18.1645 13.8399 18.4941 14.3333C18.8237 14.8266 18.9997 15.4067 18.9997 16C18.9997 16.7956 18.6836 17.5587 18.121 18.1213C17.5584 18.6839 16.7953 19 15.9997 19Z"
      fill="currentColor"
    />
  </svg>,
  'TextDocumentSearch'
);
